<template>
  <div class="evaluation">
    <div class="relative">
      <div class="input-wrapper hd">
        <div class="input-box" v-if="$store.state.entryType === 'admin'">
          <span class="name">订单归属商家：</span>
          <div class="input">
            <el-select
              placeholder="请选择"
              v-model="condition.merchantId"
              clearable
            >
              <el-option
                :label="item.label"
                :value="item.value"
                :key="item.value"
                v-for="item in filterDownData('merchantList')"
              />
            </el-select>
          </div>
        </div>
        <div class="input-box">
          <span class="name">评价类型：</span>
          <div class="input">
            <el-select
              v-model="condition.evaluateId"
              clearable
              placeholder="请选择"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                :key="item.value"
                v-for="item in filterDownData('evaluateGrade')"
              />
            </el-select>
          </div>
        </div>
        <div class="input-box">
          <span class="name">商品SKU编码：</span>
          <div class="input">
            <el-input v-model="condition.sku" placeholder="请输入" clearable />
          </div>
        </div>
        <div class="input-box">
          <span class="name">会员名称：</span>
          <div class="input">
            <el-input v-model="condition.name" placeholder="请输入" clearable />
          </div>
        </div>
        <div class="input-box" v-if="$route.name !== 'notesEvaluation'">
          <span class="name">订单号：</span>
          <div class="input">
            <el-input
              v-model="condition.orderNumber"
              placeholder="请输入"
              clearable
            />
          </div>
        </div>
        <el-button
          size="60"
          class="iconfont icon-sousuo"
          round
          @click="searchData"
        />
      </div>
      <div class="table-wrapper">
        <div class="btn-all">
          <el-button
            size="98"
            class="del-color"
            @click="handleStatus"
            v-permission:disable="$route.meta.permission"
          >
            屏蔽
          </el-button>
        </div>
        <el-table
          ref="table"
          :height="500"
          v-min-height
          :data="tableData"
          @selection-change="handleSelectionChange"
          header-cell-class-name="theader-th"
          cell-class-name="tbody-td"
        >
          <el-table-column fixed type="selection" align="center" width="130" />
          <el-table-column
            v-if="$route.name === 'notesEvaluation'"
            prop="vipId"
            label="ID"
            align="center"
            min-width="120"
          />
          <el-table-column align="center" min-width="180">
            <template slot-scope="scope">
              <el-image class="avatar" :src="scope.row.avatar" fit="cover">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>
              <p class="ellipses">
                <el-tooltip
                  effect="light"
                  placement="bottom-start"
                  :content="scope.row.name"
                >
                  <span class="goods-name"> {{ scope.row.name }}</span>
                </el-tooltip>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            align="left"
            label="商品名称/SKU编码"
            min-width="270"
          >
            <template slot-scope="scope">
              <div class="dots-all">
                <p class="dots ellipses" v-if="routeName === 'goodsEvaluation'">
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :content="scope.row.orderNumber"
                  >
                    <span class="goods-name">
                      订单号：{{ scope.row.orderNumber || '无' }}
                    </span>
                  </el-tooltip>
                </p>
                <p class="dots ellipses">
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :content="scope.row.cnName"
                  >
                    <span class="goods-name">
                      {{ scope.row.cnName || '无' }}</span
                    >
                  </el-tooltip>
                </p>
                <p class="dots ellipses">
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :content="scope.row.enName"
                  >
                    <span class="goods-name">
                      {{ scope.row.enName || '无' }}
                    </span>
                  </el-tooltip>
                </p>
                <p class="dots ellipses" v-if="routeName === 'goodsEvaluation'">
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :content="scope.row.sku"
                  >
                    <span class="goods-name">
                      SKU编码：{{ scope.row.sku || '无' }}</span
                    >
                  </el-tooltip>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="图片" min-width="270">
            <template slot-scope="scope">
              <div class="pic">
                <el-image
                  v-for="(item, index) in scope.row.img"
                  class="imgs"
                  :src="item.url"
                  :preview-src-list="imgView"
                  fit="cover"
                  :key="index"
                  @click.stop.native="switchPic(index, scope.row)"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="routeName === 'goodsEvaluation' ? '评价内容' : '笔记内容'"
            align="center"
            min-width="300"
          >
            <template slot-scope="scope">
              <span class="time">{{
                scope.row.evaluationTime || scope.row.notesTime
              }}</span>
              <p class="content ellipses">
                <el-tooltip
                  effect="light"
                  placement="bottom-start"
                  :content="
                    scope.row.evaluationContent || scope.row.notesContent
                  "
                >
                  <span class="goods-name">{{
                    scope.row.evaluationContent || scope.row.notesContent
                  }}</span>
                </el-tooltip>
              </p>
              <p class="left" v-if="routeName === 'notesEvaluation'">
                <i
                  class="iconfont icon-jiubei"
                  v-for="item in scope.row.score"
                  :key="item"
                />
              </p>
            </template>
          </el-table-column>
          <el-table-column
            v-if="routeName === 'notesEvaluation'"
            align="center"
            min-width="300"
          >
            <template slot-scope="scope">
              <!--              <p class="notes-info">-->
              <!--                <span class="categoray">-->
              <!--                  <i class="iconfont icon-fenxiang "></i>-->
              <!--                  转发-->
              <!--                </span>-->
              <!--                <span class="num">27</span>-->
              <!--              </p>-->
              <p class="notes-info">
                <span class="categoray">
                  <i class="iconfont icon-huifu"></i>
                  回复
                </span>
                <span class="num">{{ scope.row.replyNuM }}</span>
              </p>
              <p class="notes-info">
                <span class="categoray">
                  <i class="iconfont icon-dianzan"></i>
                  点赞
                </span>
                <span class="num">{{ scope.row.likeNum }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            v-if="routeName === 'goodsEvaluation'"
            label="回复"
            align="center"
            min-width="300"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.replyTime !== ''" class="time">{{
                scope.row.replyTime
              }}</span>
              <p class="content reply">
                {{ scope.row.replyContent }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            v-if="$route.name !== 'decorationApplets'"
            fixed="right"
            label="操作"
            align="center"
            min-width="180"
            class-name="visible"
          >
            <template slot-scope="scope">
              <el-button
                v-if="routeName === 'goodsEvaluation'"
                size="36"
                round
                v-permission:reply="$route.meta.permission"
                :disabled="scope.row.replyContent !== ''"
                :class="
                  scope.row.replyContent !== ''
                    ? 'iconfont icon-qipao f3'
                    : 'iconfont icon-qipao sub-color'
                "
                @click="openDialog(scope.$index)"
              />
              <el-button
                size="36"
                round
                v-permission:topping="$route.meta.permission"
                :class="
                  scope.row.isTop === '2'
                    ? 'iconfont icon-zhiding f3'
                    : 'iconfont icon-zhiding d5'
                "
                @click="handleTopping(scope.row)"
              />
              <el-button
                size="36"
                round
                v-permission:disable="$route.meta.permission"
                :class="
                  scope.row.isAnonymous === '2'
                    ? 'iconfont icon-jinyong f3'
                    : 'iconfont icon-jinyong del-color'
                "
                @click="handleStatus(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-if="pagination.recordTotal > 1"
          :currentPage="pagination.currentPage"
          :totalPage="pagination.pageTotal"
          :totalRecord="pagination.recordTotal"
          @handleNextPage="nextPage"
          @handlePrevPage="prevPage"
          @handleJumpPage="jumpPage"
          @handleChangePageSize="changePageSize"
        />
      </div>
      <div class="mask" v-if="dialogReply">
        <el-dialog
          :visible.sync="dialogReply"
          :modal-append-to-body="false"
          :close-on-press-escape="false"
          :modal="false"
          custom-class="dialog"
          :center="true"
          width="43.8rem"
        >
          <div class="box">
            <el-input
              type="textarea"
              v-model="textarea"
              clearable
              resize="none"
              placeholder="请输入回复内容"
              :autosize="{ minRows: 5, maxRows: 7 }"
            />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="98" @click="dialogReply = false" v-html="'取消'" />
            <el-button
              size="98"
              class="sub-color"
              @click="handleReply"
              v-html="'确定'"
            />
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import filterDownData from 'mixins/filterDownData'
import tableOpearting from 'mixins/tableOpearting/'

export default {
  name: 'Evaluation',
  mixins: [tableOpearting, filterDownData],
  props: {
    condition: {
      type: Object,
    },
    tableData: {
      type: Array,
    },
    pagination: {
      type: Object,
    },
  },
  data() {
    this.routeName = this.$route.name
    this.index = ''
    return {
      dialogReply: false,
      textarea: '',
      imgView: [],
    }
  },
  methods: {
    /**
     * 点击查看大图
     * @param index
     * @param row
     */
    switchPic(index, row) {
      let imgFirst = ''
      this.imgView = []
      row.img.forEach((v, i) => {
        if (index === i) {
          imgFirst = v.url
        } else {
          this.imgView.push(v.url)
        }
      })
      this.imgView.unshift(imgFirst)
    },
    /**
     * 置顶
     */
    handleTopping(row) {
      const index = +row.isTop
      const str = ['置顶该条笔记？', '取消置顶？']
      this.$confirm(str[index - 1], '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'info',
        center: true,
      })
        .then(() => {
          const state = index === 1 ? '2' : '1'
          const funType =
            this.routeName === 'goodsEvaluation'
              ? 'evaluateOpeartor'
              : 'notesOpeartor'
          this.api[funType]({
            id_array: row.id,
            change_type: 'top',
            is_top: state,
            note_status: row.isAnonymous,
          }).then(() => {
            row.isTop = state
            this.$notify({
              type: 'success',
              message: state === '1' ? '取消置顶成功~！😝' : '置顶成功~！👌',
            })
          })
        })
        .catch(() => {})
    },
    /**
     * 打开回复弹窗
     * @parma index
     */
    openDialog(index) {
      this.index = index
      this.dialogReply = true
    },
    /**
     * 回复
     */
    handleReply() {
      const row = this.tableData[this.index]
      this.api
        .replyEvaluate({
          geval_id: row.id,
          response_connect: this.textarea,
          is_top: row.isTop,
        })
        .then(() => {
          this.$notify({
            type: 'success',
            message: '回复成功~！',
          })
          this.dialogReply = false
          const condition = this._returnSearchCondition()
          this.$parent._getEvaluateList({
            curpage: this.pagination.currentPage || 1,
            ...condition,
          })
        })
    },
    /**
     * 翻页
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      const condition = this._returnSearchCondition()
      switch (this.routeName) {
        case 'goodsEvaluation':
          vm._getEvaluateList({
            curpage: newValue,
            pageSize: size,
            ...condition,
          })
          break
        case 'notesEvaluation':
          vm._getNotesList({
            curpage: newValue,
            pageSize: size,
            ...condition,
          })
          break
      }
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchCondition() {
      const { merchantId, evaluateId, sku, name, orderNumber, goodsName } =
        this.condition
      const condition = {
        member_name: name,
        goods_sku: sku,
        goods_name: goodsName,
        pay_sn: orderNumber,
        evaluate_grade: evaluateId,
        merchant_id: merchantId,
      }
      this.utils._checkSearchCondition(condition)
      return condition
    },
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchCondition()
      switch (this.routeName) {
        case 'goodsEvaluation':
          this.$parent._getEvaluateList({
            curpage: this.pagination.currentPage || 1,
            ...condition,
          })
          break
        case 'notesEvaluation':
          this.$parent._getNotesList({
            curpage: this.pagination.currentPage || 1,
            ...condition,
          })
          break
      }
    },
    /**
     * 屏蔽操作
     * @param row
     */
    handleStatus(row) {
      const funType =
        this.routeName === 'goodsEvaluation'
          ? 'evaluateOpeartor'
          : 'notesOpeartor'
      const optionType =
        this.routeName === 'goodsEvaluation' ? 'evaluate_status' : 'note_status'
      const func = (params) => {
        this.api[funType]({
          ...params,
          change_type: 'shield',
        }).then(() => {
          this.$notify({
            type: 'success',
            message: '操作成功~！😝',
          })
          const idAll = params.id_array
          if (Array.isArray(idAll)) {
            this.multipleSelection.forEach((v) => {
              v.isAnonymous = '2'
            })
          } else {
            row.isAnonymous = params[optionType]
          }
        })
      }
      if (row.id) {
        func({
          id_array: row.id,
          [optionType]: row.isAnonymous === '1' ? '2' : '1',
        })
      } else {
        func({
          id_array: this.multipleSelection
            .map((v) => {
              return v.id
            })
            .join(','),
          [optionType]: '2',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.evaluation {
  .dots-all {
    margin: 0;

    .dots {
      text-align: left;
      padding-left: 20px;

      &:before {
        left: 0;
      }

      &:nth-child(1) {
        &:before {
          background-color: #4a4a4a;
        }
      }
    }
  }

  .pic {
    display: flex;
    flex-wrap: wrap;
  }

  .imgs {
    width: 4.6rem;
    height: 4.6rem;
    background-color: #f3f3f3;
    border-radius: 0.5rem;
    margin: 0 0.6rem 0.6rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .time {
    display: inline-block;
    width: 8.9rem;
    height: 1.7rem;
    background-color: #f3f3f3;
    border-radius: 0.9rem;
    text-align: center;
    line-height: 1.7rem;
    font-size: 0.8rem;
    margin-bottom: 0.3rem;
  }

  .content {
    color: #606060;

    &.reply {
      color: #d5b68a;
    }
  }

  .f3 {
    &.icon-zhiding {
      color: rgb(201, 201, 201);

      &:after {
        content: '已置顶';
      }
    }

    &.icon-qipao {
      color: rgb(201, 201, 201);

      &:after {
        content: '已回复';
      }
    }
  }

  .sub-color {
    &.icon-qipao {
      &:after {
        content: '未回复';
      }
    }
  }

  .d5 {
    &.icon-zhiding {
      color: #fff;

      &:after {
        content: '未置顶';
      }
    }
  }

  .mask {
    textarea {
      width: 31.5rem;
      height: 18.6rem !important;
      background-color: #f7f7f7;
      border-radius: 0.3rem;
      border: 0;
    }
  }

  .icon-jiubei {
    font-size: 1.2rem;
    color: colors('bg-sub');
  }

  .left {
    display: inline-block;
    width: 8.9rem;
    text-align: left;
  }

  .notes-info {
    &:first-child {
      text-indent: -3px;
    }

    .num {
      font-weight: bold;
      color: #000;
    }
  }

  .categoray {
    display: inline-block;
    width: 60px;
    text-align: left;
  }
}
</style>
